module.exports = __webpack_public_path__ + "img/es-ar.14bacb42.svg";